import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Notification, NotificationCategories } from '@core/domain/model/notifications/notification.model';
import { NotificationIconComponent } from './notification-icon/notification-icon.component';
import { NgClass } from '@angular/common';
import { IconComponent } from '@shared/ui-components/icon/icon.component';
import { OptionsMenuComponent } from '@shared/ui-components/options-menu/options-menu.component';
import { NotificationConfig } from './notification.config';
import { ARCHIVE_OPTION, MARK_AS_READ_OPTION, UNARCHIVE_OPTION } from './notification.constants';
import { TranslateModule } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { notificationsActions } from '@store/actions/notifications.actions';
import { RouterLink } from '@angular/router';
import { NotificationDatePipe } from '@shared/pipes/date-format/notification-date.pipe';

@Component({
  selector: 'ac-notification',
  standalone: true,
  imports: [NotificationIconComponent, NgClass, IconComponent, OptionsMenuComponent, TranslateModule, RouterLink, NotificationDatePipe],
  providers: [NotificationConfig],
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationComponent {
  @Input({ required: true }) notification!: Notification;
  @Input({ required: true }) currentCategory!: NotificationCategories;
  @Input({ required: true }) isLast!: boolean;
  @Output() clicked = new EventEmitter();

  constructor(
    private readonly _store: Store<Store>,
    private readonly _config: NotificationConfig
  ) {}

  get action() {
    return this._config.getAction(this.notification ?? {});
  }

  get options() {
    return NotificationConfig.getOptions(this.notification, this.currentCategory, (optionId: string) => {
      const optionsActions = {
        [ARCHIVE_OPTION]: () => this._store.dispatch(notificationsActions.archiveOne({ notificationId: this.notification.id })),
        [MARK_AS_READ_OPTION]: () => this._store.dispatch(notificationsActions.readOne({ notificationId: this.notification.id })),
        [UNARCHIVE_OPTION]: () => this._store.dispatch(notificationsActions.unArchiveOne({ notificationId: this.notification.id })),
      };

      optionsActions[optionId as keyof typeof optionsActions]?.();
    });
  }

  onClickAction() {
    if (this.action) {
      this.clicked.emit();
      this.action?.clickLink();
      this._store.dispatch(notificationsActions.readOne({ notificationId: this.notification.id }));
    }
  }
}
